import React from 'react';

import img from './../../assets/schoolImage.png';


const Rms = () => {
    return (
        <>
        <div style={{ backgroundImage: `url(${img})`,height: '370px',
  width: '100%', backgroundRepeat:"no-repeat", backgroundSize:"cover"}} ></div>
        <div className="container-fluid px-5 mb-3" >
          
    
          <header className=" mt-3 pt-3">
            <h3>RMS Bangalore</h3>
    
          </header>
          
            <div className="section pb-3">

                <div className="content-container mt-3">
                    <p>
                        King George Royal Indian Military College, Bangalore was established on 1 August 1946 to
                        facilitate education of the sons of defence personnel from South India. Cadets were educated,
                        then from III to VI form to enable them to appear for the Army's Special Examination, which was
                        equivalent to high school education. The three Houses, at those times were Coot, Give and Cornwallis.
                    </p>
                    <p>
                        The School was reorganised in September 1952 and was thrown open to sons of commissioned officers and
                        civilians. The name of the school was shortened to King George's School. The school motto was 'Play the Game'.
                        A member of lPSC (Indian Public School Conference) the school prepared cadets for 'Senior Cambridge Examination'
                        from 1952 to 1962. The nascent patriotic fervour found its local expression when the houses were renamed as
                        Rajaji, Nehru and Mountbatten. The Mountbatten House was changed to Tagore House and a new House by name Shastri
                        House was created. In 1966, The School's name was altered to 'Bangalore Military School' and after four years of
                        its affiliation to ICSE, the school adopted a CBSE syllabus in 1967.
                    </p>
                    <p>
                        In 1969, The school's motto was changed to "Sheelam Param Bhushanm", a Sanskrit Shloka which means "Character is
                        the highest virtue'. Thereafter, the school celebrated its Diamond Jubilee from 08th Dec to 10th Dec 2006. In July
                        2007 the school was redesignated as "Rashtriya Military School" Bangalore.
                    </p>
                </div>
            </div>
        </div>
</>

    );
};

export default Rms;
